export const MAX_ASPECT_RATIO = 12 / 7;
export const PHOTO_HEIGHT = 882;
export const MAX_HEIGHT = `calc(100vw / ${MAX_ASPECT_RATIO})`;
